import React from "react";
import {Icon} from '../createSvg'
import {IconProps} from "../types";

export const Site = (props: IconProps) => {
    return (
        <Icon {...props}>
            <path
                d="M5 19h4v-7H3v5c0 1.1.9 2 2 2zm5 0h10c1.1 0 2-.9 2-2v-5H10v7zM3 7v4h19V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2z"/>
        </Icon>
    )
}

